import classNames from 'classnames'
import { _x } from '@wordpress/i18n'

function LayoutToggle(props: {
  variant: 'desktop' | 'mobile'
  value: 'list' | 'map'
  onChange: (value: 'list' | 'map') => void
}) {
  const buttonClassNames = classNames(
    'btn btn-sm filter-panel-button',
    props.variant === 'desktop' &&
      'btn-square--mobile icon-text-hidden--mobile btn-outline-default'
  )

  return (
    <button
      type="button"
      className={buttonClassNames}
      onClick={() => props.onChange(props.value === 'list' ? 'map' : 'list')}
      aria-label={
        props.value === 'list'
          ? _x('Display map', 'Layout Toggle Label', 'icf')
          : _x('Hide map', 'Layout Toggle Label', 'icf')
      }
    >
      <i className="icon icon--fixed-width fa-map" />
      <span>
        {props.variant === 'mobile'
          ? _x('Map', 'Layout Toggle Label', 'icf')
          : props.value === 'list'
            ? _x('Display map', 'Layout Toggle Label', 'icf')
            : _x('Hide map', 'Layout Toggle Label', 'icf')}
      </span>
    </button>
  )
}

export default LayoutToggle
